import { LanguageType } from 'types';

type LanguageOption = {
  label: string;
  value: LanguageType;
};

export const Languages: Array<LanguageOption> = [
  { value: 'en', label: 'English' },
  { value: 'fr', label: 'Français' },
  { value: 'nl', label: 'Nederlands' },
  { value: 'de', label: 'Deutsch' },
];

export const translations = {
  valve: {
    en: 'Valve',
    nl: 'Afsluiter',
    fr: 'Vanne',
    de: 'Armatur',
  },
  actuator: {
    en: 'Actuator',
    nl: 'Aandrijving',
    fr: 'Actionneur',
    de: 'Antrieb',
  },
  monitoring: {
    en: 'Monitoring',
    nl: 'Switchbox',
    fr: 'Contacteur',
    de: 'Endschalter',
  },
  solenoid: {
    en: 'Solenoid',
    nl: 'Stuurventiel',
    fr: 'Électrovanne piloté',
    de: 'Steuerventil',
  },
  service: {
    en: 'Service',
    nl: 'Dienst',
    fr: 'Service',
    de: 'Service',
  },
  insert: {
    en: 'Insert',
    nl: 'Invoegen',
    fr: 'Insérer',
    de: 'Einfügen',
  },
  actuatorHeading: {
    en: 'Actuator sizing is based on:',
    nl: 'De afmetingen van de actuator zijn gebaseerd op:',
    fr: "Le dimensionnement de l'actionneur est basé sur:",
    de: 'Die Dimensionierung des Aktuators basiert auf:',
  },
  diffPress: {
    en: 'Differential pressure',
    nl: 'Drukverschil',
    fr: 'Pression différentielle',
    de: 'Differenzdruck',
  },
  supplyPress: {
    en: 'Supply pressure',
    nl: 'Leveringsdruk',
    fr: "Pression d'alimentation",
    de: 'Versorgungsdruck',
  },
  safety: {
    en: 'Safety',
    nl: 'Veiligheid',
    fr: 'Sécurité',
    de: 'Sicherheit',
  },
  medium: {
    en: 'Medium',
    nl: 'Medium',
    fr: 'Moyen',
    de: 'Mittel',
  },
  mounting: {
    en: 'Mounting',
    nl: 'Montage',
    fr: 'Montage',
    de: 'Montage',
  },
  in_line: {
    en: 'In line',
    nl: 'In lijn',
    fr: 'En ligne',
    de: 'Im Einklang',
  },
  cross_line: {
    en: 'Cross line',
    nl: 'Kruis lijn',
    fr: 'Ligne croisée',
    de: 'Kreuzlinie',
  },
  articleNumber: {
    en: 'article no.',
    nl: 'artikel nr.',
    fr: 'article no.',
    de: 'artikel-nr.',
  },
  stemExtension: {
    en: 'Stem Extension',
    nl: 'Verlengspindel',
    fr: 'Rallonge de tige',
    de: 'Spindelverlängerung',
  },
  pucks: {
    en: 'Pucks',
    nl: 'Schakel puck',
    fr: 'Activateur de position',
    de: 'Pucks',
  },
  speedControlBlock: {
    en: 'Speed control block',
    nl: 'Snelheidsregelblok',
    fr: 'Bloc régulateur de vitesse',
    de: 'Speed control block',
  },
  operations: {
    en: 'Operations',
    nl: 'Operations',
    fr: 'Opérations',
    de: 'Bediening',
  },
  couplings: {
    en: 'Couplings',
    nl: 'Koppelstukken',
    fr: 'Accouplements',
    de: 'Couplings',
  },
  brackets: {
    en: 'Brackets',
    nl: 'Beugels',
    fr: 'Consoles',
    de: 'Brackets',
  },
};
